module.exports = __webpack_public_path__ + "img/fenleiguanli_mr.54bee5de.svg";